import P from '../pages';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux'
import FormHeader from './FormHeader';
import Alert from './Alert';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import { CustomFormGroup, Form } from '../../../shared/components';
import { defaultMessages } from '../../../libs/i18n/default';
import withDefaults from './withDefaults'
import { guestProfileSubmit } from '../actions';
import { generateProfileElementObject, setProfileElementsFromState } from '../../../shared/profileElementHelpers';
import { changeState, getAge, optionsFromArray} from '../../../shared/utilities';
import { pageValid, fieldsToValidate } from '../../../shared/validator';

const GuardianEmergency = ({ page, dispatch, content, user, territory, environment, intl: { formatMessage } }) => {
  const thisPage = P.GUARDIAN_EMERGENCY_PAGE;
  const [submitted, setSubmitted] = useState(false)
  const containerClass = territory.code == 'SRSC' ? 'col-md-12' : 'col-md-6'
  const relationshipSelections = {
    legalGuardian: useSelector(state => state.localProfileElements.elements.contact.legal_guardian_relationship_selections),
    emergencyContact: useSelector(state => state.localProfileElements.elements.contact.emergency_contact_relationship_selections)
  }
  const [fields, setFields] = useState({
    guardianName: generateProfileElementObject('', 'contact', 'guardian', 'name'),
    guardianRelationship: generateProfileElementObject('', 'contact', 'guardian', 'relationship'),
    guardianPhone: generateProfileElementObject('', 'contact', 'guardian', 'phone'),
    guardianEmail: generateProfileElementObject('', 'contact', 'guardian', 'email'),
    legalGuardianName: {
      ...generateProfileElementObject('', 'contact', 'legal_guardian', 'name'),
      validationKey: user.guest.type.code != 'college-student' && 'profile_elements_contact_legal_guardian_name'
    },
    legalGuardianRelationship: {
      ...generateProfileElementObject('', 'contact', 'legal_guardian', 'relationship'),
      validationKey: user.guest.type.code != 'college-student' && 'profile_elements_contact_legal_guardian_relationship'
    },
    legalGuardianRelationshipOther: {
      ...generateProfileElementObject('', 'contact', 'legal_guardian', 'relationship_other'),
      validationKey: user.guest.type.code != 'college-student' && 'profile_elements_contact_legal_guardian_relationship_other',
      dependentObj: 'legalGuardianRelationship',
      dependencyMet: (dependentObj = fieldsRef.current.legalGuardianRelationship) => (dependentObj.val == 'Other')
    },
    legalGuardianPhone: {
      ...generateProfileElementObject('', 'contact', 'legal_guardian', 'phone'),
      validationKey: user.guest.type.code != 'college-student' && 'profile_elements_contact_legal_guardian_phone'
    },
    legalGuardianEmail: {
      ...generateProfileElementObject('', 'contact', 'legal_guardian', 'email'),
      validationKey: user.guest.type.code != 'college-student' && 'profile_elements_contact_legal_guardian_email'
    },
    emergencyContactName: generateProfileElementObject('', 'contact', 'emergency_contact', 'name'),
    emergencyContactRelationship: generateProfileElementObject('', 'contact', 'emergency_contact', 'relationship'),
    emergencyContactRelationshipOther: {
      ...generateProfileElementObject('', 'contact', 'emergency_contact', 'relationship_other'),
      dependentObj: 'emergencyContactRelationship',
      dependencyMet: (dependentObj = fieldsRef.current.emergencyContactRelationship) => (dependentObj.val == 'Other')
    },
    emergencyContactPhone: generateProfileElementObject('', 'contact', 'emergency_contact', 'phone'),
    emergencyContactEmail: generateProfileElementObject('', 'contact', 'emergency_contact', 'email')
  })
  const fieldsRef = useRef(fields)
  fieldsRef.current = fields

  useEffect(() => {
    fieldsToValidate(fields).forEach(f => {
      handleChange(f, fields[f].val, false)
    })
  }, [])

  const handleChange = (key, val, resetDependentObject = true) => {
    changeState(
      fieldsRef.current,
      key,
      val,
      (newObj) => {
        setFields({...fieldsRef.current, ...newObj})
      },
      resetDependentObject
    )
  }

  const submit = (e) => {
    e.preventDefault();
    setSubmitted(true)
    dispatch(guestProfileSubmit({
      contact: {
        emergency_contact: {
          name: fields.emergencyContactName.val,
          relationship: fields.emergencyContactRelationship.val,
          relationship_other: fields.emergencyContactRelationshipOther.val,
          phone: fields.emergencyContactPhone.val,
          email: fields.emergencyContactEmail.val
        },
        guardian: {
          name: fields.guardianName.val,
          relationship: fields.guardianRelationship.val,
          phone: fields.guardianPhone.val,
          email: fields.guardianEmail.val
        },
        legal_guardian: {
          name: fields.legalGuardianName.val,
          relationship: fields.legalGuardianRelationship.val,
          relationship_other: fields.legalGuardianRelationshipOther.val,
          phone: fields.legalGuardianPhone.val,
          email: fields.legalGuardianEmail.val
        }
      }
    }, thisPage))
  }

  const under18Fields = () => (
    (getAge(user.dob) <= 18 || user.guest.type.code == 'high-school-student' || user.guest.type.code == 'college-student') &&
    <div>
      {profileFields('guardian', 'guardian')}
      {profileFields('legalGuardian', 'legal_guardian')}
    </div>
  )

  const name = (kind) => {
    return (
      <div style={{flex: '50%'}}>
        <CustomFormGroup field={fields[`${kind}Name`]}>
          <ControlLabel>{formatMessage(defaultMessages.clientCommonName)}</ControlLabel>
          <FormControl id={`${kind}Name`}
            type="text"
            componentClass="input"
            defaultValue={fields[`${kind}Name`].val}
            onChange={e => handleChange(e.target.id, e.target.value)}/>
        </CustomFormGroup>
      </div>
    )
  }

  const phone = (kind) => {
    return (
      <div style={{flex: '50%'}}>
        <CustomFormGroup field={fields[`${kind}Phone`]}>
          <ControlLabel>{formatMessage(defaultMessages.clientCommonPhone)}</ControlLabel>
          <FormControl id={`${kind}Phone`}
            type="text"
            componentClass="input"
            defaultValue={fields[`${kind}Phone`].val}
            onChange={e => handleChange(e.target.id, e.target.value)}/>
        </CustomFormGroup>
      </div>
    )
  }

  const email = (kind) => {
    return (
      <div style={{flex: '50%'}}>
        <CustomFormGroup field={fields[`${kind}Email`]}>
          <ControlLabel>{formatMessage(defaultMessages.clientCommonEmail)}</ControlLabel>
          <FormControl id={`${kind}Email`}
            type="text"
            componentClass="input"
            defaultValue={fields[`${kind}Email`].val}
            onChange={e => handleChange(e.target.id, e.target.value)}/>
        </CustomFormGroup>
      </div>
    )
  }

  const relationship = (kind) => {
    let srsc = territory.code == 'SRSC'
    return (
      <div style={{flex: '50%'}}>
        <CustomFormGroup field={fields[`${kind}Relationship`]}>
          <ControlLabel>{formatMessage(defaultMessages.clientCommonRelationship)}</ControlLabel>
          {
            srsc
            ? <FormControl id={`${kind}Relationship`}
                type='select'
                componentClass='select'
                defaultValue={fields[`${kind}Relationship`].val}
                onChange={e => handleChange(e.target.id, e.target.value)}>
                {optionsFromArray(relationshipSelections[kind], formatMessage)}
              </FormControl>
            : <FormControl id={`${kind}Relationship`}
                type='text'
                componentClass='input'
                defaultValue={fields[`${kind}Relationship`].val}
                onChange={e => handleChange(e.target.id, e.target.value)} />
          }
        </CustomFormGroup>
      </div>
    )
  }

  const profileFields = (kind, profileElement) => (
    useSelector(state => state.user.guest.type.guest_profile_elements).includes(profileElement) &&
    <div>
      <div className="row">
        <h5 className={'col-md-12'} style={{margin: 'auto'}}>{content.pages.guardian_emergency[profileElement]}</h5>
      </div>
      <hr/>
      <div className='two-columns'>
        {name(kind)}
        {phone(kind)}
      </div>
      <div className='two-columns'>
        {email(kind)}
        {relationship(kind)}
      </div>
      {
        territory.code == 'SRSC' &&
        <CustomFormGroup field={fields[`${kind}RelationshipOther`]}>
          <ControlLabel>{formatMessage(defaultMessages.clientCommonOther)}</ControlLabel>
          <FormControl id={`${kind}RelationshipOther`}
            type="text"
            componentClass="input"
            defaultValue={fields[`${kind}RelationshipOther`].val}
            onChange={e => handleChange(e.target.id, e.target.value)}/>
        </CustomFormGroup>
      }
    </div>
  )

  return (
    <Form page={page} thisPage={thisPage} back={user.guest.kind == 'standard'} skip={environment != 'production'} submitFunc={submit} disableSubmit={!pageValid(fields) || submitted} >
      <FormHeader title={content.pages.guardian_emergency.title} />
      {profileFields('emergencyContact', 'emergency_contact')}
      {under18Fields()}

      {
        territory.code != 'SRSC' &&
        <Alert alert={content.pages.guardian_emergency.info} />
      }
    </Form>
  )
}

export default withDefaults(GuardianEmergency);
